<template>
  <FreeBottomSheet name="apply-cashback-info-bottom-sheet">
    <template #default="{ hide }">
      <div class="flex flex-col space-y-4 p-4">
        <div class="text-text-neutral-primary flex flex-col space-y-2">
          <div class="text-xl font-semibold">
            {{ t('loyalty.cashback-info.title') }}
          </div>
          <div>{{ t('loyalty.cashback-info.content') }}</div>
        </div>
        <FreeButton type="button" class="green-main-button" @click="hide()">
          {{ t('loyalty.cashback-info.confirm') }}
        </FreeButton>
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { FreeBottomSheet, FreeButton } from 'freedom-shared';

  const { t } = useI18n();
</script>
